export const NEW_ALERT_CLASS = 'new-alert';
export const ALERT_TABS_ID = 'alert-tabs';
